module.exports = __webpack_public_path__ + "img/fig25.304707f9.jpg";